import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	panel: {
		backgroundColor: tokens.colorNeutralBackground1,
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		...shorthands.gap(tokens.spacingVerticalL),
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	},
	cardContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	dataUsage: {
		width: '60px',
		height: '60px',
	},
	progressBar: {
		width: '200px',
	},
});

export default useStyles;
